import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useBallastTypesApi } from "../../../../../http/border/useBallastTypes";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { BORDER } from "../../AdminSystemSettings";
import BallastTypeForm from "./BallastTypeForm";

const EditBallastType: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { ballastTypeId } = useParams<{ ballastTypeId: string }>();
  const ballastTypesApi = useBallastTypesApi();

  const aborter = useRef(new AbortController());
  const { data, error, isMutating, trigger } = ballastTypesApi.getAdminBallastType(
    ballastTypeId!,
    aborter.current.signal,
  );

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: BORDER },
    {
      url: `/admin/systems/${systemId}/settings?tab=4&bal_t=1`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.ballastTypes.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    ballastTypeId && trigger();
  }, [ballastTypeId]);

  return (
    <>
      <Header title={`${i18n.translation.ballastTypes.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <BallastTypeForm
          ballastType={!error ? data : undefined}
          isDisabled={isMutating || !!error}
          isLoading={!data && !error}
          tabbed
        />
      </FlexContent>
    </>
  );
};

export default EditBallastType;
